import React, { useState } from "react";
import PasswordEyeIcon from "./assets/passwordEyeIcon.png";
import Logo from "./assets/frLogo.png";

const SetPassword = () => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // toggle functions
  const toggleShowNewPassword = () => {
    setShowNewPassword((prev) => !prev);
  };

  const toggleShowConfirmPassword = () => {
    setShowConfirmPassword((prev) => !prev);
  };

  return (
    <div className="setPassword-root">
      <div className="loho-bar">
        <img src={Logo} alt="logo" className="f-logo" />
      </div>
      <div className="cnfrm-password-box">
        <div className="cnf-heading">
          <p>Create New Password</p>
        </div>
        <div className="cnf-sub">
          <p>
            Create a new strong password, that you don’t use for other websites.
          </p>
        </div>

        <div className="pwd-box">
          {/* New Password Field */}
          <div
            className="user-input-box pass-box"
            style={{ position: "relative" }}
          >
            <label className="u-label" style={{ color: "black" }}>
              New Password
            </label>

            <img
              src={PasswordEyeIcon}
              alt="password-eye-icon"
              className="password-eye-icon"
              onClick={toggleShowNewPassword}
              style={{
                cursor: "pointer",
                position: "absolute",
                right: "10px",
                top: "65%",
                transform: "translateY(-50%)",
              }}
            />
            <input
              type={showNewPassword ? "text" : "password"}
              placeholder="Enter your new password"
              className="input-box passsord-width-corrector"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
          </div>

          {/* Confirm Password Field */}
          <div
            className="user-input-box pass-box"
            style={{ position: "relative" }}
          >
            <label className="u-label" style={{ color: "black" }}>
              Re-enter Password
            </label>

            <img
              src={PasswordEyeIcon}
              alt="password-eye-icon"
              className="password-eye-icon"
              onClick={toggleShowConfirmPassword}
              style={{
                cursor: "pointer",
                position: "absolute",
                right: "10px",
                top: "65%",
                transform: "translateY(-50%)",
              }}
            />
            <input
              type={showConfirmPassword ? "text" : "password"}
              placeholder="Re-Enter your new password"
              className="input-box passsord-width-corrector"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>

          {/* Pswd Btns */}
          <div className="pswd-btns">
            <div className="cancel-pwd-btn">
              <p style={{ margin: 0 }}>CANCEL</p>
            </div>
            <div className="save-pwd-btn">
              <p style={{ margin: 0 }}>SAVE</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SetPassword;
